exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown-form .dropdown-menu {\n  padding: 10px\n}\n", ""]);

// exports
